import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

if (process.env.NODE_ENV === "development" && process.env.REACT_APP_ENABLE_MSW === "true") {
  import("./mockServer").then(({ default: worker }) => worker.start());
} else if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => registrations.forEach((registration) => registration.unregister()));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
